import React, {
    ChangeEvent,
    useCallback,
    useContext,
    useEffect,
    useMemo, useRef,
    useState
} from "react";
import { ObjectMap, useFrame, useLoader, useThree } from '@react-three/fiber'
import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import "./ReplaceModel.scss";
// @ts-ignore
import model from "../../../../assets/3d/ACE_PLAYGROUND_RB_3103_1430.gltf";
import carTexture from "../../../../assets/textures/DHL_busje_002_UV.png";
import {
    AnimationMixer, Color,
    DirectionalLight, Group,
    Mesh, MeshBasicMaterial, MeshPhongMaterial, MeshPhysicalMaterial,
    MeshStandardMaterial,
    PointLight,
} from "three";
import { gui } from "../../../../App";
import { OrbitControls, Plane, useTexture } from "@react-three/drei";
import { Button } from "../../../Button/Button";
import { PortalContentContext } from "../../../../context/PortalContentContext";
import { ClickableHeatPoints } from "./ClickableHeatPoints/ClickableHeatPoints";
import { get, orderBy, set, uniqBy, unset } from "lodash";
import gsap from "gsap";
interface IProps {
}

const lightValues = {
    Light: {
        intensity: 0,
        color: '#ffb34e'
    },
    Light001: {
        intensity: 0.328,
        color: '#ffffff'
    },
    Light002: {
        intensity: 0.0845,
        color: '#FFFFFF',
    },
    Light003: {
        intensity: 0.132,
        color: '#FFFFFF',
    },
    Light004: {
        intensity: 1.263,
        color: '#ffb34e',
    }
}


const textureMaterials: {[key: string]: MeshBasicMaterial} = {};
let mixer: AnimationMixer;

export function Blue3DText(props: IProps) {
    const { setContent: setPortalContent } = useContext(PortalContentContext);
    const gltf = useLoader(GLTFLoader, model) as (GLTF & ObjectMap);
    const {
        scene,
    } = useThree();

    const [lights, setLights] = useState<(PointLight | DirectionalLight)[]>([]);
    const [guiState, setGuiState] = useState({
        shouldLoad: false,
        loaded: false,
    });
    const [showModelUpload, setShowModelUpload] = useState(false);
    const [sceneModel, setSceneModel] = useState<GLTF>();
    const [mills, setMills] = useState<{[key: string]: Mesh}>({})
    const [clouds, setClouds] = useState<Mesh[]>([]);
    const orbitControlsRef = useRef<any>(null);
    const [hasOrbitControls, setHasOrbitControls] = useState(false);
    const DHLCarTexture = useTexture(carTexture);
    DHLCarTexture.flipY = false

    const textures = useMemo(() => {
        return {
            mapTexture: {
                DHLCarTexture,
                // buildingTexture,
                // akkerTexture
            }
        };
    }, [DHLCarTexture]);

    useEffect(() => {
        setSceneModel(gltf);
    }, [gltf]);

    const loadedModel = sceneModel?.scene;

    useMemo(() => {
        if (!guiState.shouldLoad || guiState.loaded) return;

        lights.forEach((light) => {
            const settings = get(lightValues, light.name);

            gui.add(light, 'intensity', 0, 2, .001)
                .name(`${light.name}: Intensity`)
                .setValue(settings.intensity)
            gui.addColor(light, 'color')
                .name(`${light.name}: Color`)
                .setValue(new Color().set(light.color))
        })
        // console.log({lig});
        // gui.add(lightState.directional, 'intensity', 0, 2, .001)
        //     .name('Directional strength')
        //     .onChange((value: number) => {
        //         setLightState((prevState) => {
        //             return {...prevState, directional: {
        //                 ...prevState.directional,
        //                     intensity: value,
        //                 }};
        //         });
        //     })
        //     .setValue(lightState.directional.intensity);
        // gui.addColor(lightState.directional, 'color')
        //     .name('Directional color')
        //     .onChange((value: string) => {
        //         setLightState((prevState) => {
        //             return {...prevState, directional: {
        //                 ...prevState.directional,
        //                     color: value,
        //                 }};
        //         });
        //     })
        //     .setValue(lightState.directional.color);
        // gui.add(lightState.points, 'intensity', 0, 2, .001)
        //     .name('Point strength')
        //     .onChange((value: number) => {
        //         setLightState((prevState) => {
        //             return {...prevState, points: {
        //                     ...prevState.points,
        //                     intensity: value,
        //                 }};
        //         });
        //     })
        //     .setValue(lightState.points.intensity);
        // gui.addColor(lightState.points, 'color')
        //     .name('Points color')
        //     .onChange((value: string) => {
        //         setLightState((prevState) => {
        //             return {...prevState, points: {
        //                     ...prevState.points,
        //                     color: value,
        //                 }};
        //         });
        //     })
        //     .setValue(lightState.directional.color);
        setGuiState((prevState) => {
            return {...prevState, loaded: true};
        })
    }, [guiState, lights]);

    useEffect(() => {
        if (!loadedModel) return;

        console.log('LOADED MODEL');

        scene.add(loadedModel);
        return () => {
            scene.remove(loadedModel);
        }
    }, [loadedModel, scene, textures]);

    useEffect(() => {
        if (!loadedModel) return;
        mixer = new AnimationMixer(loadedModel);
        gltf.animations.forEach((animation) => {

            if (!animation.name.toLowerCase().includes('morph')) {
                mixer.clipAction(animation).play();
            }
        });
        console.log('LOADED ANIMATIONS');
    }, [gltf, loadedModel]);

    // apply textures
    useEffect(() => {
        // Prepare a set of materials
        // Each material gets named by the combination of textures
        // So, mapTexture=car gets its own material
        // And, mapTexture=car,aoTexture=carAo gets it own material
        // Each mesh has set of keys / values, which result in a list of materials
        if (!loadedModel) return;
        let modelHasAppliedTextures = false;
        loadedModel.traverse((child) => {
            if (child.userData?.appliedTexture) {
                modelHasAppliedTextures = true;
            }
        });
        if (modelHasAppliedTextures) return;

        loadedModel.traverse((child) => {
            // Really important, find and apply textures
            if (child.userData?.appliedTexture)  {
                return;
            }
            const textureKeys = Object.keys(child.userData).filter((key) => key.split('Texture').length > 1);
            const textureKeyValues: string[] = [];
            textureKeys.forEach((textureKey) => {
                const value = child.userData[textureKey];
                textureKeyValues.push(`${textureKey}=${value}`);
            });
            const materialKey = textureKeyValues.join(',');
            if (materialKey.length > 0) {
                let material: MeshBasicMaterial | undefined = get(textureMaterials, materialKey);
                if (!material) {
                    const params: any = {};
                    let applyMaterial = false;
                    textureKeys.forEach((textureKey) => {
                        const setOfTextures = get(textures, textureKey);
                        const textureType = textureKey.replace('Texture', '');
                        const thisObjectsTextureSetting = get(child.userData, textureKey);
                        const foundTexture = get(setOfTextures, thisObjectsTextureSetting);
                        if (foundTexture) {
                            params[textureType] = foundTexture;
                            applyMaterial = true;
                        } else {
                            console.log(`${textureKey.toUpperCase()} WITH NAME ${thisObjectsTextureSetting} NOT FOUND`);
                        }
                    })
                    if (!applyMaterial) return;
                    material = new MeshPhongMaterial({...params});
                }
                const mesh = child as Mesh;
                mesh.material = material;
                set(mesh.userData, 'appliedTexture', true);
            }
        });
        console.log('DETECTED TEXTURES');
    }, [loadedModel, textures])

    // Detect the lights
    useEffect(() => {
        if (!loadedModel) {
            console.log('DETECTED NO LIGHTS');
            setLights([]);
            return;
        }
        const lightsCollection: (DirectionalLight | PointLight)[] = [];
        loadedModel.traverse((child) => {
            if (child.type === 'DirectionalLight') {
                const directionalLight = child as DirectionalLight;
                lightsCollection.push(directionalLight);
            }
            if (child.type === 'PointLight') {
                const pointLight = child as PointLight;
                // pointLight.intensity = 0.599;
                // pointLight.castShadow = true;

                lightsCollection.push(pointLight);
            }
        });

        if (lightsCollection.length > 0) {
            setLights(lightsCollection);
        }
        setGuiState(prevState => {
            return {...prevState, shouldLoad: true};
        })
        console.log('DETECTED LIGHTS');
    }, [loadedModel]);

    // Detect the materials
    useEffect(() => {
        if (!loadedModel) {
            console.log('DETECTED NO MATERIALS');
            return;
        }
        let materials: (MeshStandardMaterial | MeshPhongMaterial | MeshPhysicalMaterial)[] = [];
        loadedModel.traverse((child) => {
            if (child.type === 'Mesh') {
                const mesh = child as Mesh;
                if ((mesh.material as any).type === 'MeshStandardMaterial') {
                    materials.push(mesh.material as MeshStandardMaterial);
                }
                if ((mesh.material as any).type === 'MeshPhongMaterial') {
                    materials.push(mesh.material as MeshPhongMaterial);
                }
                if ((mesh.material as any).type === 'MeshPhysicalMaterial') {
                    materials.push(mesh.material as MeshPhysicalMaterial);
                }
            }
        });
        materials = orderBy(uniqBy(materials, 'name'), ['name'], ['asc']);

        gui.folders.forEach((folder) => {
            if (folder._title === 'Materials') {
                folder.destroy();
            }
        });

        console.log('DETECTED MATERIALS');

        requestAnimationFrame(() => {
            const folder = gui.addFolder('Materials');
            materials.forEach((material) => {
                folder
                    .addColor(material, 'color')
                    .name(material.name)
            })
        })
    }, [loadedModel]);

    // Detect the windmills
    useEffect(() => {
        if (!loadedModel) {
            console.log('DETECTED NO MILLS');
            setMills({});
            return;
        }
        const millsCollection: {[key: string]: Mesh} = {};
        loadedModel.traverse((child) => {
            if (child.name.split('Windmolen').length > 1 && child.children.length > 0) {
                millsCollection[child.name] = child as Mesh;
            }
        });
        setMills(millsCollection);
        console.log('DETECTED MILLS');
    }, [loadedModel]);

    // Detect the clouds
    useEffect(() => {
        if (!loadedModel) {
            console.log('DETECTED NO CLOUDS');
            setClouds([]);
            return;
        }
        const cloudsCollection: Mesh[] = [];
        loadedModel.traverse((child) => {
            if (child.name.toLowerCase().split('wolk').length > 1) {
                child.userData.randomSpeedMultiplier = Math.random() * 0.125;
                cloudsCollection.push(child as Mesh);
            }
        });
        setClouds(cloudsCollection);
        console.log('DETECTED CLOUDS');
    }, [loadedModel]);

    // Detect elevator
    useEffect(() => {
        if (!loadedModel) {
            console.log('DETECTED NO ELEVATOR');
            return;
        }
        let elevator: Group | undefined = undefined;
        loadedModel.traverse((child) => {
            if (child.name === 'E_Lift') {
                elevator = child as Group;
            }
        });
        if (!elevator) {
            console.log('DETECTED NO ELEVATOR');
            return;
        }
        console.log('DETECTED ELEVATOR');

        elevator = elevator as Group;

        const floorPosition = elevator.position.y;
        const roofPosition = 3.4;

        let elevatorTimeout: NodeJS.Timeout;

        const moveElevator = () => {
            const direction = elevator?.position.y === roofPosition ? 'down' : 'up';
            const y = direction === 'down' ? floorPosition : roofPosition;
            gsap.to(elevator!.position, {
                y,
                duration: .5,
            });

            const max = 20 * 1000;
            const min = 10 * 1000;

            elevatorTimeout = setTimeout(() => {
                moveElevator();
            }, Math.random() * (max - min) + min)
        }

        elevatorTimeout = setTimeout(() => {
            moveElevator();
        }, 10000);

        return () => {
            clearTimeout(elevatorTimeout);
        }
    }, [loadedModel]);


    // Windmills
    const rotateMills = useCallback((time: number) => {
        const angle = 3 * time;
        Object.values(mills).forEach((mill, index) => {
            const [blades] = mill.children;
            blades.rotation.z = index + angle * -1;
        })
    }, [mills]);

    // Move clouds
    const moveClouds = useCallback(() => {
        Object.values(clouds).forEach((cloud, index) => {
            const randomSpeed = cloud.userData.randomSpeedMultiplier * 0.25;
            let newZ = cloud.position.z -= randomSpeed;
            if (newZ < -50) {
                newZ = 50;
            }
            cloud.position.z = newZ;
        })
    }, [clouds]);

    // Camera rotation
    // const handleCameraRotation = useCallback((time: number) => {
    //     if (hasOrbitControls) return;
    //     if ((document as any).canvasTouched) return;
    //     const angle = angleDivider * (time - ((document as any).canvasTouchedTime ?? 0));
    //     (document as any).angle = angle;
    //     // const angle = Math.PI * 2;
    //     // console.log({angle, cos: Math.cos(angle) * cameraOffset});
    //
    //     camera.position.x = Math.cos(angle) * cameraOffset;
    //     camera.position.z = Math.sin(angle) * cameraOffset;
    //     camera.position.y = 8 + Math.sin(angle * .5) * 4;
    //
    //     camera.lookAt(0, 0, 0);
    // }, [camera, hasOrbitControls]);

    useFrame((state, delta) => {
        const time = state.clock.getElapsedTime();
        moveClouds();
        rotateMills(time);
        mixer?.update(delta);
        // handleCameraRotation(time);
    });

    // Enable disable orbitcontrols when user hits the O
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'o') {
                setHasOrbitControls(!hasOrbitControls);
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, [hasOrbitControls]);

    useEffect(() => {
        // Debugging: Handle modelupload
        const handleModelUpload = (event: ChangeEvent) => {
            const input = event.target as HTMLInputElement;
            // console.log({event});
            // use the 1st file from the list
            let f = input.files?.[0];

            let reader = new FileReader();

            // Closure to capture the file information.
            reader.onload = ((theFile) => {
                return (e: any) => {
                    (new GLTFLoader()).parse(e.target.result, '', (data) => {
                        setSceneModel(data);
                    });
                };
            })(f);

            // Read in the image file as a data URL.
            reader.readAsText(f!);
        }
        if (!showModelUpload) return;
        setPortalContent((prevState) => {
            const copy = {...prevState};
            copy['modelUpload'] = <div className="replace-model-interface">
                <Button variant={"hollow"}>Replace model</Button>
                <input type="file" accept={'.gltf'} onChange={handleModelUpload}/>
            </div>;
            return copy;
        });
        return () => {
            setPortalContent((prevState) => {
                const copy = {...prevState};
                unset(copy, 'modelUpload');
                return copy;
            });
        }
    }, [setPortalContent, showModelUpload]);

    // Toggle model upload
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'u') {
                setShowModelUpload((prevState) => !prevState);
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, []);

    // Rotate on touch
    // useEffect(() => {
    //     if (!camera) return;
    //     const touchFinishTime = 500;
    //     const canvas = document.querySelector('.scene-canvas-wrapper canvas') as HTMLCanvasElement;
    //
    //     let startTouch = (new Date()).getTime();
    //     let startX = 0;
    //     let finishingTouchTimeout: NodeJS.Timeout;
    //     const handleTouchStart = (e: PointerEvent) => {
    //         if (!(document as any).canvasTouched) {
    //             (document as any).canvasTouched = true;
    //             startTouch = (new Date()).getTime();
    //         }
    //         startX = e.clientX;
    //         clearTimeout(finishingTouchTimeout);
    //
    //
    //         // const a = Math.acos(camera.position.x / cameraOffset);
    //         // console.log({ A: a });
    //         // const degrees = Math.acos(camera.position.x / cameraOffset);
    //         // const angle = degrees + (Math.PI / 2);
    //         // console.log({ angle, degrees });
    //     }
    //     const handleTouchMove = (e: PointerEvent) => {
    //         if (!(document as any).canvasTouched) return;
    //         const distance = e.clientX - startX;
    //         const duration = (new Date()).getTime() - startTouch;
    //         const speed = distance / duration;
    //         const angle = ((document as any).angle as number) * (1 + speed);
    //
    //         camera.position.x = Math.cos(angle) * cameraOffset;
    //         camera.position.z = Math.sin(angle) * cameraOffset;
    //         camera.position.y = 8 + Math.sin(angle * .5) * 4;
    //
    //         camera.lookAt(0, 0, 0);
    //
    //         // console.log({ distance, speed });
    //     }
    //     const handleTouchEnd = (e: PointerEvent) => {
    //         finishingTouchTimeout = setTimeout(() => {
    //             const duration = (new Date()).getTime() - startTouch;
    //             (document as any).canvasTouchedTime = ((document as any).canvasTouchedTime ?? 0) + duration / 1000;
    //             (document as any).canvasTouched = false;
    //         }, touchFinishTime);
    //     }
    //     canvas.addEventListener('pointerdown', handleTouchStart);
    //     canvas.addEventListener('pointermove', handleTouchMove);
    //     canvas.addEventListener('pointerup', handleTouchEnd);
    //     // canvas.addEventListener('pointerleave', handleTouchEnd);
    //     // canvas.addEventListener('pointercancel', handleTouchEnd);
    //     // canvas.addEventListener('pointerout', handleTouchEnd);
    //
    //     return () => {
    //         canvas.removeEventListener('pointerdown', handleTouchStart);
    //         canvas.removeEventListener('pointermove', handleTouchMove);
    //         canvas.removeEventListener('pointerup', handleTouchEnd);
    //         // canvas.removeEventListener('pointerleave', handleTouchEnd);
    //         // canvas.removeEventListener('pointercancel', handleTouchEnd);
    //         // canvas.removeEventListener('pointerout', handleTouchEnd);
    //     }
    // }, [camera])

    const handleOrbitControlsStart = () => {
        document.body.classList.add('orbit-moving');
    }
    const handleOrbitControlsEnd = (e: any) => {
        // console.log({e});
        // console.log(orbitControlsRef);
        // const controls = orbitControlsRef.current;
        document.body.classList.remove('orbit-moving');
        // controls.reset();
        // console.log({ controls });
    }

    return (
        <>
            <Plane material-color={"#9d9d9d"} args={[1000, 1000]} rotation={[Math.PI * -.5, 0, 0]} position={[0, -0.5, 0]}></Plane>
            <hemisphereLight intensity={1} color={'#c1daff'} groundColor={'#adadad'} />
            {/*<Car position={[0, 1, 0]} />*/}
            <OrbitControls
                ref={orbitControlsRef}
                autoRotate={!hasOrbitControls}
                minDistance={8}
                minPolarAngle={Math.PI * 0.2}
                maxPolarAngle={Math.PI / 2.4}
                maxDistance={45}
                zoomSpeed={.5}
                enablePan={hasOrbitControls}
                onStart={handleOrbitControlsStart}
                onEnd={handleOrbitControlsEnd}
                autoRotateSpeed={1}
            />
            {loadedModel ? <ClickableHeatPoints /> : null}
            {/*<PortalContents>*/}
            {/*    <div className="point point-a" ref={pointARef}>*/}
            {/*        <PulseButton className={"small filled"} onClick={handleHeatButtonClick('welcome')}>{t('scene.subjects.welcome.title')}</PulseButton>*/}
            {/*    </div>*/}
            {/*    <div className="point point-b" ref={pointBRef}>*/}
            {/*        <PulseButton className={"small filled"} onClick={handleHeatButtonClick('sales')}>{t('scene.subjects.sales.title')}</PulseButton>*/}
            {/*    </div>*/}
            {/*    <div className="point point-c" ref={pointCRef}>*/}
            {/*        <PulseButton className={"small filled"} onClick={handleHeatButtonClick('production')}>{t('scene.subjects.production.title')}</PulseButton>*/}
            {/*    </div>*/}
            {/*    <div className="point point-d" ref={pointDRef}>*/}
            {/*        <PulseButton className={"small filled"} onClick={handleHeatButtonClick('warehousing')}>{t('scene.subjects.warehousing.title')}</PulseButton>*/}
            {/*    </div>*/}
            {/*    <div className="replace-model-interface">*/}
            {/*        <Button variant={"hollow"}>Replace model</Button>*/}
            {/*        <input type="file" accept={'.gltf'} onChange={handleModelUpload}/>*/}
            {/*    </div>*/}
            {/*</PortalContents>*/}
        </>
    )
}
